
import { Component, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { Socket } from "ngx-socket-io";
import { UsersService } from "../services/users.service";
import { Subject } from "rxjs";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CasinoProviderComponent } from "../casino-provider/casino-provider.component";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [HeaderComponent, CasinoProviderComponent, FooterComponent],
})
export class DashboardComponent implements OnInit, OnDestroy {
  offer_data: any;
  banner_img: any;
  allMessages = [];
  homeData: any;
  walletuser: any;
  dataLength: number;
  cricketData: any;
  soccerData: any;
  tennisData: any;
  kabbadiData: any;
  virtualCricketData: any;
  ballbyballData: any;
  tableTennisData: any;
  volleyballData: any;
  basketballData: any;
  moment: any = moment;
  inplay: any = false;
  selectedSportData: any;
  userDetails: any;
  targetElement: Element;
  tokenCheck: boolean = false;
  avaialablePlayBattle: any;
  avaialableContest: any;
  logo: any;
  currentUrl: string = '';
  support: any;
  supportdata: any;
  user: any;
  support_nO: any;
  logintokenscreen: any;
  modalRefcancel: BsModalRef;
  aviatorArr: any;
  aviatorlog: any;
  Contest_menu: any;
  gapcasino_menu: any;
  playerbattle_menu: any;
  kabaddi_menu: any;
  tabletennis_menu: any;
  virtuallog: boolean = false;
  ballArr: any;
  ballbycricket: any;
  wallet_status: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private socket: Socket,
    private usersService: UsersService,
    private modalService: BsModalService,
  ) {
    this.getBanner();
    this.route.params.subscribe((params) => {
      if (params.sportName === undefined) {
        if (sessionStorage.getItem("loginStatus") === "true") {

          this.settings();
        } else {
          //this.homeFreeSoc();
          this.tokenCheck = true;
        }
      } else if (
        params.sportName === "inplay" &&
        sessionStorage.getItem("loginStatus") === "true"
      ) {
        this.Inplay();
        this.inplay = true;
        this.settings();
      }
    });

  }


  async getDetials() {
    try {
      const data = await JSON.parse(sessionStorage.getItem("userDetails"));
      return data;
    } catch (e) {
      return null;
    }
  }

  isInPlayRoute(): boolean {
    return this.router.url === '/dashboard/inplay';
  }
  isInPlaybatle(): boolean {
    return this.router.url === '/dashboard';
  }

  home() {

    this.router.navigate(["home"]);
  }

  async ngOnInit(): Promise<void> {

    this.homeSoc('none');
    this.getsupport()
    this.targetElement = document.querySelector("html");
    const usrDetails = await this.getDetials();
    this.user = usrDetails;
    if (usrDetails) {
      this.get_marque_msgg();
    }
    this.currentUrl = this.router.url;
    //console.log('Current URL:', this.currentUrl);
    // this.getusertoken();
    // this.getUserBalance(); 


  }
  async settings() {
    this.userDetails = await this.getDetials();

    const data = { user_id: this.userDetails.details._id };
    this.usersService.SocketPost("menusetting", data).subscribe((res: any) => {
      //console.log(res);
      var available_events = res;
      if (available_events) {
        // this.wallet_status=available_events?.manager?.wallet_status;
        var available_event = available_events.eventTypes;
        const available_user = available_events.user.availableEventTypes;

        // Map event types to menu variables
        const eventMap = {
          'b9': 'ballbycricket',
          'aviator': 'aviatorlog',
          'v9': 'virtuallog',
          '3902': 'Contest_menu',
          '3901': 'playerbattle_menu',
          '27979456': 'kabaddi_menu',
          '8': 'tabletennis_menu',
          '18': 'volleyball_menu',
          '15': 'basketball_menu',
          'g9': 'gapcasino_menu',
        };

        // Initialize menu visibility
        Object.keys(eventMap).forEach((id) => {
          const menuKey = eventMap[id];
          const isEventAvailable = available_user.includes(id);
          const event = available_event.find((data) => data.eventType.id === id);
          // console.log(isEventAvailable);
          this[menuKey] = event?.visible_status && isEventAvailable;

        });
      }
    });
  }

  public cricket(section: string) {
    window.location.hash = '';
    window.location.hash = section;
  }

  openDialog2(myModal: TemplateRef<any>) {
    localStorage.setItem('firstVisit', 'result');
    this.modalRefcancel = this.modalService.show(
      myModal,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }


  myRefreshEvent(event: Subject<any>, message: string) {
    setTimeout(() => {
      alert(message);
      event.next();
    }, 3000);
  }

  alert(message: string) {
    alert(message);
  }

  async Inplay() {

    this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };

    this.usersService.SocketPost("get-inplay-markets", data).subscribe((res: any) => {
      if (res) {
        // sessionStorage.setItem(cacheKey3,JSON.stringify({ inplayMarkets: res, timestamp: Date.now() }));
        // console.log(res.data);
        this.dataLength = res.data?.length;
        this.cricketData = [];
        this.soccerData = [];
        this.tennisData = [];
        this.kabbadiData = [];
        this.tableTennisData = [];
        this.volleyballData = [];
        this.basketballData = [];

        for (let i = 0; i < res.data?.length; i++) {
          const sortInplayFirst = (
            a: { marketBook: { inplay: boolean } },
            b: { marketBook: { inplay: boolean } }
          ) => {
            if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
            return a.marketBook?.inplay ? -1 : 1; // true first
          };

          if (res.data[i].eventTypeId == 4) {
            this.cricketData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🏏 Cricket Data:', this.cricketData);
          } else if (res.data[i].eventTypeId == 1) {
            this.soccerData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('⚽ Soccer Data:', this.soccerData);
          } else if (res.data[i].eventTypeId == 2) {
            this.tennisData = res.data[i].markets.sort(sortInplayFirst);

          }
          else if (res.data[i].eventTypeId == 27979456) {
            this.kabbadiData = res.data[i].markets.sort(sortInplayFirst);

          }
          else if (res.data[i].eventTypeId == 8) {
            this.tableTennisData = res.data[i].markets.sort(sortInplayFirst);
            //console.log(this.tableTennisData);
          }
          else if (res.data[i].eventTypeId == 18) {
            this.volleyballData = res.data[i].markets.sort(sortInplayFirst);
            console.log(this.tableTennisData);
          }
          else if (res.data[i].eventTypeId == 15) {
            this.basketballData = res.data[i].markets.sort(sortInplayFirst);
            console.log(this.tableTennisData);
          }

        }
      }
      else {
        this.toastr.error(res.message, 'Error!');
      }
    });

  }

  // checkVirtualShow() {
  //   if (
  //     this.virtualCricketData?.length &&
  //     this.virtualCricketData[0]?.managerStatus[
  //       this.userDetails.details.manager
  //     ] === true
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }


  async homeSoc(id) {

    const cachedData = sessionStorage.getItem("cacheKey");

    if (cachedData) {
      const { markets, timestampB } = JSON.parse(cachedData);
      // Check if cache is still valid (5 minutes = 300,000 ms)
      if (Date.now() - timestampB < 60 * 1000) {
        this.processResponse(markets);
        return; // Use cached message
      } else {
        sessionStorage.removeItem('cacheKey'); // Clear expired cache
      }
    }

    // API call if no valid cache found
    const timestampMs = Date.now();
    const timestamp = 198728782826 * timestampMs;
    this.userDetails = await this.getDetials();
    let data
    if (this.userDetails == null) {
      data = {};
    } else {
      data = {
        user_id: this.userDetails.details._id,
        timestamp: timestamp,
        // ...(id !== "none" && { eventTypeId: id }) // Add eventTypeId only if provided
      };
    }

    this.usersService.SocketPost("get-market-eventTypeWise", data).subscribe((res: any) => {
      if (res) {
        var markets = res;
        // Save message to localStorage with timestamp
        sessionStorage.setItem("cacheKey", JSON.stringify({ markets: markets, timestampB: Date.now() }));
        this.processResponse(markets);
      }
    });

  }

  // Separate function to process and store response data
  processResponse(res) {
    this.dataLength = res.data.length;

    for (let i = 0; i < res.data.length; i++) {
      const sortInplayFirst = (
        a: { marketBook: { inplay: boolean } },
        b: { marketBook: { inplay: boolean } }
      ) => {
        if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
        return a.marketBook?.inplay ? -1 : 1;
      };

      const event = res.data[i];

      if (event.eventTypeId == 4) {
        this.cricketData = event.markets.sort(sortInplayFirst);
        // console.log('🏏 Cricket Data:', this.cricketData);
      } else if (event.eventTypeId == 1) {
        this.soccerData = event.markets.sort(sortInplayFirst);
        // console.log('⚽ Soccer Data:', this.soccerData);
      } else if (event.eventTypeId == 2) {
        this.tennisData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
      else if (event.eventTypeId == 27979456) {
        this.kabbadiData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 kabbadi Data:', this.kabbadiData);
      }
      else if (event.eventTypeId == 8) {
        this.tableTennisData = event.markets.sort(sortInplayFirst);
      }
      else if (event.eventTypeId == 18) {
        this.volleyballData = event.markets.sort(sortInplayFirst);

      }
      else if (event.eventTypeId == 15) {
        this.basketballData = event.markets.sort(sortInplayFirst);

      }
    }
  }

  async findHostName() {
    return window.location.hostname;
  }

  async getHost() {
    const hostname = await this.findHostName();
    const splithostname = hostname.split(".");
    this.logo = splithostname[0];
    this.setManager(splithostname[0]);
  }

  setManager(hostname: any) {
    if (hostname === "clubprt") {
      this.getOffer("PRTCLUB");
    } else if (hostname === "ferrariclubb") {
      this.getOffer("FERRARICLUB");
    } else if (hostname === "clubaob") {
      this.getOffer("AOBCLUB");
    } else if (hostname === "dlexch") {
      this.getOffer("DLCLUB");
    } else if (hostname === "fairbets247") {
      this.getOffer("FAIRBET");
    } else if (hostname === "clubosg") {
      this.getOffer("");
    } else if (hostname === "clubosg" || hostname === "dubaiclub247") {
      this.getOffer("OSGCLUB");
    } else if (hostname === "clublucky7") {
      this.getOffer("PRTLUCKY");
    }
    else if (hostname === "telegrambook") {
      this.getOffer("TELEGRAMBOOK");
    }
    else if (hostname === "kitbook") {
      this.getOffer("KITBOOK");
    }
    else {
      this.getOffer("OSGMANAGER");
    }
  }

  getBanner() {
    this.getHost();
    this.usersService.Get("get-banner/").subscribe((response: any) => {


      this.banner_img = [];
      if (response.error) {
        this.toastr.error(response.message, "Error!");
      } else {
        this.banner_img = response.response;
      }
    });
  }

  getOffer(manager_name) {
    const data = { filter: { manager: manager_name, visible: true } };
    this.usersService
      .post_api("get-offer/", data)
      .subscribe((response: any) => {
        this.offer_data = [];
        if (response.error) {
          this.toastr.error(response.message, "Error!");
        } else {
          this.offer_data = response.data;
        }
      });
  }

  async get_marque_msgg() {
    this.userDetails = await this.getDetials();
    var data = { user_id: this.userDetails.details._id, }
    this.usersService.SocketPost("getMessage", data).subscribe((res: any) => {
      //console.log("get_marque_msgg", res);
      const response = res.response;
      if (response.admin) {
        this.allMessages.push(response.admin.message);
      }
      if (response.master) {
        this.allMessages.push(response.master.message);
      }
      if (response.manager) {
        this.allMessages.push(response.manager.message);
      }
      // console.log("All Messages:", this.allMessages);

    });
  }


  goToDashboard(sportName, id, data) {
    if (id == -100) {
      this.router.navigate(["casino"]);
    } else if (id < -100) {
      this.router.navigate([
        "snova/" + id + "/" + data.name + "/" + data.providerCode,
      ]);
    } else {
      this.router.navigate(["dashboard/" + sportName]);
    }
  }

  checkInplayStatus(value): boolean {
    let CurrentDate = new Date();
    const currDate = CurrentDate.toISOString();
    if (currDate > value) {
      return true;
    } else {
      return false;
    }
  }

  openCasino(gameID: string) {
    const data = { gameId: gameID };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    // this.route.navigate(['./casino-url']);
    this.router.navigate(["./casino-url"]);

  }
  openDaimond(gameID: string) {
    const data = { gameId: gameID };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    // this.route.navigate(['./casino-url']);
    this.router.navigate(["./diamondtable-url"]);

  }

  async getsupport() {

    this.userDetails = await this.getDetials();
    // this.alert(JSON.stringify(this.userDetails?.details?._id));
    let data
    let domain = window.location.hostname;
    // let domain='clubosg.com';
    if (this.userDetails == null) {
      data = {
        loginStatus: false,
        domain: domain,
      }
    } else {
      data = {
        user_id: this.userDetails.details._id,
        loginStatus: true,
        domain: domain,
      }
    }
    this.supportData(data);


  }

  supportData(data: any) {
    this.usersService.SocketPost("get-support ", data).subscribe((res: any) => {
      if (res) {
        //  console.log(res);
        this.support = res.data;

      }
      else {
        // console.warn(res.message);
      }
    });
  }

  opengapss(gameID: string): void {
    // console.log('OPEN CASINO GAME ID:', gameID);
    if (!gameID) {
      console.error('Game ID is missing');
      return;
    }
    const data = {
      gameId: String(gameID)
    };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    this.router.navigate(['/casino-gap-url']);
  }

  matchDetail(eventId, eventTypeId) {
    this.router.navigate(["match-detail", eventId, eventTypeId]);
  }

  virtualDetial(eventId: any, eventTypeId: any) {
    this.router.navigate(["virtual-detail", eventId, eventTypeId,]);
  }

  onClickofSport(sport) {
    this.selectedSportData = sport;
  }

  goToInplay(sportName) {
    this.router.navigate(["dashboard/" + sportName]);
  }


  ngOnDestroy() {
    this.socket.removeAllListeners();
  }
}
